import React, { useEffect, useState } from 'react'
import { Box, Text, Image } from '@chakra-ui/react'
import Link from 'next/link';
import slugify from 'slugify';
import { storage } from '../../src/config/firebase';
import { ListingLink } from '../../styles/NewLandingStyles';
import { getDownloadURL } from 'firebase/storage';

const ListingCards = ({ item, last }) => {

    const { id, price, address, subject, primaryImg} = item;

    const [image, setImage] = useState(null)

    function getImage(id, primaryImg) {
        const listingRef = ref(storage, `listingImages/${id}/compressed/${imageName}_700x700.${imageExtension}`);

        let imageName = primaryImg?.split(".")[0];
        let imageExtension = primaryImg?.split(".")[1];

        getDownloadURL(listingRef).then(url => {
            setImage(url)
        }).catch(e => 0)

        // await listingRef.child(`${imageName}_700x700.${imageExtension}`).getDownloadURL().then(url => {
        //     setImage(url)
        // }).catch(e => 0)
    }

    useEffect(() => {
        getImage(id, primaryImg)
    }, [item]);
    String.prototype.toProperCase = function () {
        return this.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
    };
    return (
        (<Link key={id} href={`/listings/${encodeURIComponent(id)}/${slugify(subject)}`}>
            <ListingLink last={last}>
                    <Box maxW="sm" rounded="lg" overflow="hidden" shadow={"md"} width={{ base: "312px", md: "100%" }} height={"100%"} _hover={{ shadow: "lg", cursor: "pointer" }}>

                        {/* <Image src={"/images/newLanding/demoListing.png"} height={{ base: "180px", md: "125px", lg: "180px" }} /> */}
                        {/* <Image src={item?.image} layout={"fill"} /> */}

                        <Image src={image} height={{ base: "180px", md: "125px", lg: "180px" }} />

                        <Box p="6">
                            <Box display="flex" alignItems="baseline">
                                <Text
                                    color="black"
                                    fontWeight="500"
                                    fontSize={{ base: "16px", md: "12px", lg: "15px" }}
                                    lineHeight={{ base: "22px", md: "17px", lg: "22px" }}
                                >
                                    {subject.toProperCase()}
                                </Text>
                            </Box>

                            <Text
                                my="10px"
                                color="gray.400"
                                fontSize="12px"
                                fontWeight="normal"
                                lineHeight="17px"
                            >
                                #{address}
                            </Text>

                            <Text fontSize={"16px"} lineHeight={"22px"}>
                                ${(price).toLocaleString("en")}
                            </Text>
                        </Box>
                    </Box>
            </ListingLink>
        </Link >)
    );
}

export { ListingCards }
